import React from 'react'

const IconAllocation = (props) => {
    return (
        <svg {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2001_264)">
                <path d="M36.5779 27.0013C35.4328 29.7093 33.6418 32.0956 31.3614 33.9515C29.081 35.8074 26.3807 37.0764 23.4966 37.6477C20.6125 38.2189 17.6323 38.0749 14.8167 37.2283C12.001 36.3817 9.43567 34.8583 7.34483 32.7912C5.25399 30.7241 3.70135 28.1763 2.82265 25.3705C1.94395 22.5647 1.76594 19.5864 2.30419 16.6959C2.84245 13.8055 4.08057 11.0908 5.91031 8.78942C7.74006 6.488 10.1057 4.66984 12.8005 3.4939" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M38 19.9996C38 17.6358 37.5345 15.2952 36.6299 13.1114C35.7254 10.9276 34.3995 8.94336 32.7281 7.27195C31.0567 5.60054 29.0724 4.2747 26.8886 3.37013C24.7048 2.46557 22.3642 2 20.0005 2V19.9996H38Z" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_2001_264">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default IconAllocation